<template>
    <div id="Points" class="app-inner">
         <div class="p-tit-c">
             <div class="businessList-filter">
                <div class="businessList-filter-list flex align-cen">
                      <div class="fl-le flex align-cen">
                    <div class="label">用户编号：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入用户编号" v-model="search" clearable> </el-input>
                    </div>
                    </div>
                     <div class="fl-rt flex align-cen">
                    <div class="label">手机号：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入手机号" v-model="search2" clearable> </el-input>
                    </div>
                    </div>
                     <div class="fl-rt flex align-cen">
                    <div class="label">用户昵称：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入用户昵称" v-model="search1" clearable> </el-input>
                    </div>
                    </div>
                </div>
                 <div class="businessList-filter-list flex align-cen public-btn-small">
                        <div class="public-btn-small-primary" @click="dataSuccess">
                        搜索
                        </div>
                        <div class="public-btn-small-plan" @click="exportExcel(multipleSelection)">
                        导出
                        </div>
                        <div class="public-btn-small-text" @click="reset">
                        重置筛选条件
                        </div>
                    </div>
             </div>
         </div>
          <div class="businessList-container">
            <div class="businessList-container-table">
                           <el-table
          ref="multipleTable"
          :data="itemList"
          tooltip-effect="dark"
          style="width: 100%"
          border
          :row-key="getRowKeyOfTarget"
          @selection-change="handleSelectionChange"
          id='mytable'
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"
        >
          <el-table-column type="selection" width="55" reserve-selection align="center" fixed="left"> </el-table-column>
          <el-table-column prop="id" label="用户id" align="center" width="150">
          </el-table-column>
            <el-table-column prop="loginName" label="手机号" align="center" width="150">
          </el-table-column>
           <el-table-column  label="所属企业" align="center" width="200">
            <template slot-scope="scope">
               <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="openDialog(scope.row)">{{scope.row.businessNum}}条记录/查看记录</el-button>
            </template>
          </el-table-column>
        <el-table-column prop="userName" label="用户昵称" align="center">
          </el-table-column>
          <el-table-column prop="score" label="可用积分" align="center">
          </el-table-column>
           <el-table-column prop="totalScore" label="历史积分" align="center">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            align="center"
            >
            <template slot-scope="scope">
                <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="detail(scope.row)">查看明细</el-button>
                  <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="openPutPoins(scope.row)">修改数值</el-button>
            </template>
            </el-table-column>
         </el-table>
                 <el-pagination
          class="jiange"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageSizes"
          :page-size="PageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
            </div>
          </div>
                    <!-- 增加企业弹窗 -->
         <el-dialog
            title="所属企业"
            :visible.sync="centerDialogVisible"
            width="50%"
            :append-to-body="true"
            center>
            <el-table
            :data="buArr"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
            <el-table-column
            prop="id"
            label="企业ID"
           align="center"
             >
            </el-table-column>
            <el-table-column
            prop="name"
            label="企业名称"
           align="center"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="是否为企业管理员" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.isAdmin == 0
                  ? "否"
                  : "是"
              }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <!-- 修改数值窗口 -->
        <el-dialog
            title="修改数值"
            :visible.sync="centerDialogVisible1"
            width="500px"
            :append-to-body="true"
            center>
             <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  增加积分输入整数即可、减少积分输入负整数即可，如：-100
            </div>
        </div>
                <div class="businessList-filter">
                <div class="businessList-filter-list flex align-cen">
                      <div class="fl-le flex align-cen">
                    <div class="label">调整积分：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入积分" v-model="integral" clearable style="width:380px"> </el-input>
                    </div>
                    </div>
                </div>
                 <div class="businessList-filter-list flex align-cen">
                      <div class="fl-le flex align-cen">
                    <div class="label">备注信息：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入备注【1-50】" type="textarea" :rows="4" v-model="remark" clearable style="width:380px"
                        minlength="1"
                        maxlength="50"
                        > </el-input>
                    </div>
                    </div>
                </div>
                   <div class="businessList-filter-list flex align-cen public-btn-small" style="justify-content: flex-end;">
                         <div class="public-btn-small-plan" style="margin-right:30px" @click="centerDialogVisible1 = false">
                        取消
                        </div>
                          <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load"
                            @click.stop="putSorce"
                            >
                              确定
                            </el-button>
                    </div>
                </div>
        </el-dialog>
    </div>
</template>
<script>
import exportExcel from '../../../utils/exportExcel.js' //导出数据公共方法
import {getbusinessAccountList,businessAccountDetail,updateScore} from "@/api/index/index"  //用户列表、用户详情、修改积分
export default {
    name:'Points',
    data() {
        return {
            search:'',
            search1:'',
            multipleSelection:[],
            itemList:[],
            totalNum:0,
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount: 0,
            pageSizes:[10,20,30,40,50,100],
            buArr:[],
            centerDialogVisible:false,
            centerDialogVisible1:false,
            integral:'',
            remark:'',
            accountId:'',
            search2:'',
            loading:false,
        }
    },
        activated(){
  this.gethisInfo()
},
    created() {
        
    },
    methods: {
        // 打开修改数值窗口
        openPutPoins(data){
            this.integral = ""
            this.remark = ""
            this.accountId = data.id
            this.centerDialogVisible1 = true
        },
        // 修改积分
        putSorce(){
            let reg = /^-?[0-9][0-9]*$/;
            if(!this.integral) return this.$message.error('请输入积分')
            if(!reg.test(this.integral)) return this.$message.error('请输入正确的值')
            this.loading = true
             updateScore({
                accountId:this.accountId,
                integral:this.integral,
                remark:this.remark
              })
            .then(res => {
              this.loading = false
               if(res.code == 0){
                this.$message.success('修改成功')
                this.gethisInfo()
               }else{
                this.$message.error('修改失败')
               }
             this.centerDialogVisible1 = false
            })
            .catch(err => {
              this.loading = false
            })
        },
        // 打开积分明细
        detail(data){
             this.$router.push({
            name: "poinsDetail",
            query:{
                id:data.id,
            }
           })
        },
       // 打开企业弹框窗口
        openDialog(data){
                businessAccountDetail({
                id:data.id
              })
            .then(res => {
                this.buArr = res.data.platformBusinessList
            })
            .catch(err => {
            })
            this.centerDialogVisible = true
        },
    // 搜索
    dataSuccess(){
        this.current = 1
        this.gethisInfo()
    },
    // 重置
    reset(){
        this.search = ""
        this.search1 = ""
         this.search2 = ""
         this.current = 1
        this.gethisInfo()
    },
    // 导出
    exportExcel(val){
          if(val.length !=0){
        let keyLisst = [] 
            for(let item in val){
             keyLisst.push( {
              '用户ID':val[item].id, 
              '手机号':val[item].loginName,
              '所属企业':val[item].businessNum + '家',
              '用户昵称':val[item].userName, 
              '可用积分':val[item].score,
              '历史积分':val[item].totalScore,
              } ) 
             }
         exportExcel.exportExcel(keyLisst,this.$route.meta.title)
             }else{
                this.$message.error('未选择导出数据')
             }
    },
                   // 获取列表
        gethisInfo(){
            let params = {
                id:this.search,
                userName:this.search1,
                loginName:this.search2,
                source:'',
                businessId:'',
                businessName:'',
                current: this.currentPage,
                size:this.PageSize,
            }
            getbusinessAccountList(params)
            .then(res => {
              this.itemList = res.data.records
             this.totalCount = res.data.total;
            })
            .catch(err => {
            })
        },
     getRowKeyOfTarget(row) {
            return row.id
    },
           // 表格选择
         handleSelectionChange(val) {
        this.multipleSelection = val;
      },
           handleSizeChange(val) {
       this.PageSize = val
       this.gethisInfo()
    },
    handleCurrentChange(val) {
      this.currentPage = val
       this.gethisInfo()
    },
    },
}
</script>
<style lang="scss" scoped>
    .businessList-container-table {
      margin-top: 20px;
      .el-switch {
        position: relative;
        z-index: 1 !important;
      }
      .el-switch.is-disabled {
        opacity: 1 !important;
      }
      .buStatus{
        width: 50px;
        margin: 0 auto;
      }
    }
    .jiange {
      margin-top: 20px;
    }
    ::v-deep {
     .el-dialog{
      
            .el-dialog__header{
                background: #ccc;
               border-radius: 2px 2px 0 0;
            }
     }
}
</style>